import React from 'react'
import BitePageSection from '../components/PageSections/BitePageSection'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'



function Bites() {
  return (
    <div>
      <NavBar/>
      <BitePageSection/>
      <Footer/>

    </div>
  )
}

export default Bites